import { Box, Flex, Text } from '@chakra-ui/react';
import snapShareImage from '../images/snap-and-share.jpg';

const SnapAndShare: React.FC = () => {
  return (
    <Box alignContent="center" textAlign="center" color="white">
      <Flex
        alignItems="center"
        w="100vw"
        h="90vh"
        bg={`url(${snapShareImage})`}
        bgSize="cover"
        bgPos="center"
        pos="relative"
      >
        <Box
          position="absolute"
          top="0"
          left="0"
          width="100%"
          height="100%"
          bgColor="#1f2535"
          mixBlendMode={'multiply'}
          opacity="0.5"
        ></Box>
        <Text fontSize="40px" zIndex={10} w="full" textAlign="center" px={4}>
          CAPTURE THE LOVE, SHARE THE MOMENT
        </Text>
      </Flex>
      <Box mt={12} mb={12}>
        <Text fontSize="2xl">SNAP & SHARE</Text>
        <Text fontSize="sm" mt={2}>
          Help us capture our special day and share it by using our hashtags:
        </Text>
        <Text fontSize="sm" fontWeight="bold" fontStyle="italic" mt={2} mb={2}>
          #CARRIEntlyMarryingKESH
        </Text>
        <Text fontSize="sm" fontWeight="bold" fontStyle="italic" mt={2} mb={2}>
          #CARRIEfoundherlucKESHarm
        </Text>
        <Text fontSize="sm" fontWeight="bold" fontStyle="italic" mt={2} mb={2}>
          #KESHisCARRIEsANNEsweredprayer
        </Text>
        <Text fontSize="sm" fontWeight="bold" fontStyle="italic" mt={2} mb={2}>
          #KESHandCARRIEmallMakati
        </Text>
      </Box>
    </Box>
  );
};

export default SnapAndShare;
